import React from 'react'

export default class Loading extends React.Component {
  render(){
    return(
      <div className='loading'>
        <img alt='loading' src={require('../loader.svg')}/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Loading.js